
import { Building } from "lucide-react";

export const AboutHero = () => {
  return (
    <div className="bg-gradient-to-b from-primary/20 to-background py-16">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center space-y-4">
          <Building className="w-16 h-16 mx-auto text-primary" />
          <h1 className="text-4xl font-bold">About Home Pros OKC</h1>
          <p className="text-xl text-muted-foreground">
            Connecting Oklahoma City homeowners with trusted service professionals
          </p>
        </div>
      </div>
    </div>
  );
};
